import React, {useEffect, useState} from "react";
import useSerializedRefresh from "../../../useSerializedRefresh";
import ApiService from "../../../../../services/ApiService";

export default function ScreenDonSection({context,campagneData})
{
    const [loading,setLoading]=useState(true)
    const [dons,setDons]=useState([])

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })

    const partnerMontant=campagneData?.partnerMontant || 1

    const screenOptions=campagneData?.screenOptions || {}

    const getDisplayName=(campagneExtraData={})=>{
        return campagneExtraData?.displayName || "Anonyme"
    }

    const getDons=async ()=>{
        let url="/campagne/donors/"+campagneData.id

        const res=await ApiService.get(url)
        let _dons=res.data

        if(screenOptions.minMontant){
            _dons=_dons.filter(i=>i.montant>=screenOptions.minMontant)
        }

        setDons(_dons)
        setLoading(false)
    }

    useSerializedRefresh(getDons, campagneData?._liveRevision)


    if(loading){
        return null
    }

    // On garde seulement les 3 derniers pour l'affichage actif
    const visibleDons=dons.slice(0,3)

    return (
        <div style={{
            overflow:"visible",
            width:"100%",
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            flexDirection:"row",
            gap:"1.5vw",
            padding:"0 3vw"
        }}>
            {visibleDons.map((d,index)=>{
                return(
                    <div
                        key={d.id}
                        className={"screen-don-card screenDonFadeIn"}
                        style={{
                            paddingLeft:"5vw",
                            paddingRight:"1.5vw",
                            display:"flex",
                            flexDirection:"column",
                            alignItems:"center",
                            justifyContent:"center"
                        }}
                    >
                        <span style={{
                            color:"#A63042",
                            fontSize:"3.2vh",
                            textAlign:"center",
                            fontFamily:"Oswald-DemiBold",
                            fontWeight:"normal",
                            lineHeight:1.1,
                            whiteSpace:"nowrap",
                            overflow:"hidden",
                            textOverflow:"ellipsis",
                            maxWidth:"100%"
                        }}>
                            {getDisplayName(d.campagneExtraData)}
                        </span>
                        <span style={{
                            color:"#B69E5C",
                            fontSize:"3vh",
                            textAlign:"center",
                            fontFamily:"PlayfairDisplay-MediumItalic",
                            fontStyle:"italic",
                            fontWeight:"normal",
                            marginTop:"0.3vh",
                            whiteSpace:"nowrap"
                        }}>
                            {formater.format(d.montant/partnerMontant)} {context.getDonorName(formater.format(d.montant/partnerMontant))}
                        </span>
                    </div>
                )
            })}
        </div>
    )
}
